import { render, staticRenderFns } from "./Resumes.vue?vue&type=template&id=b2190d54&scoped=true&"
import script from "./Resumes.vue?vue&type=script&lang=js&"
export * from "./Resumes.vue?vue&type=script&lang=js&"
import style0 from "./Resumes.vue?vue&type=style&index=0&id=b2190d54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2190d54",
  null
  
)

export default component.exports